export const UrlPath = {
	index: "/index.html",
    aboutHPPC: "/aboutHPPC.html",
	aboutStablePower: "/aboutStablePower.html",
	aboutPowerTalent: "/aboutPowerTalent.html",
	aboutPowerReport: "/aboutPowerReport.html",
	energyTransitionResponsibility: "/energyTransitionResponsibility.html",
	energyTransitionRenewable: "/energyTransitionRenewable.html",
	energyTransitionReduceCarbon: "/energyTransitionReduceCarbon.html",
	otec: "/otec.html",
	environmentCircular: "/environmentCircular.html",
	environmentWater: "/environmentWater.html",
	environmentAir: "/environmentAir.html",
	environmentOcean: "/environmentOcean.html",
	environmentReport: "/environmentReport.html",
	environmentSeaReport: "https://hppower.seawatch.com.tw/",
	safetyHealth: "/safetyHealth.html",
	justTransition: "/justTransition.html",
	justTransitionCarbonCollege: "/justTransitionCarbonCollege.html",
	socialEducation: "/socialEducation.html",
	socialConservation: "/socialConservation.html",
	socialTribe: "/socialTribe.html",
	socialRelief: "/socialRelief.html",
	joinBenefit: "/joinBenefit.html",
	joinPractice: "/joinPractice.html",
	social: "/social.html",	
	join: "/join.html",
	newsList: "/newsList.html",
	newsArticle: "/newsArticle.html"
}

export const Util = {
	TIMESTAMP: new Date().getTime(),
	WEB_ENVIRONMENT: "",
	getDomWidth: () => {
		return document.documentElement.clientWidth;
	},
	getDomHeight: () => {
		return document.documentElement.clientHeight;
	},
	getUrlString: (str: string) => {
		const reg = new RegExp("(^|&)"+str+"=([^&]*)(&|$)", "i");
		const r = window.location.search.substr(1).match(reg);
	
		if(r!=null) 
			return(r[2]);
					
		return "";
	},
	setThousands: (val: string) => {
		val += "";
		const arr = val.split(".");
		const re = /(\d{1,3})(?=(\d{3})+$)/g;
		return arr[0].replace(re, "$1,") + (arr.length == 2 ? "." + arr[1] : "");
	},
	chkWebEnv: () => {
		const host = location.host;
		//var hostname = location.hostname;
		//var pathname = location.pathname;
		//var href = location.href;
	
		if(host.indexOf("www.hppc.com") >= 0) {
			Util.WEB_ENVIRONMENT = "PRD";
		} else if(host.indexOf("192.168") >= 0) {
			Util.WEB_ENVIRONMENT = "QAS";
		} else {
			Util.WEB_ENVIRONMENT = "DEV";
		}

		console.log(Util.WEB_ENVIRONMENT);
	},
	setUrl: (fileName: string) => {
		// console.log("host = " + location.host);
		// console.log("hostname = " + location.hostname);
		// console.log("pathname = " + location.pathname);
		// console.log("href = " + location.href);
		// console.log("origin = " + location.origin);
		// console.log("protocol = " + location.protocol);

		let url = "";
		const host = location.host;

		if(host.indexOf("www.hppc.com.tw") >= 0) { // PRD
			url = location.origin + "/tw" + fileName;
		} else if(host.indexOf("192.168") >= 0) { // QAS
			url = location.origin + "/tw" + fileName;
		} else { // DEV
			url = location.origin + fileName;
		}

		return url;
	},
	// setRESTful: (pathName) => {
	// 	let url = "";
	// 	let host = location.host;
		
	// 	if(host.indexOf("gempower.energy") >= 0) { // PRD
	// 		url = "https://" + location.host + pathName;
	// 	} else { // QAS or DEV
	// 		url = "http://192.168.203.166:8080" + pathName;
	// 	}
		
	// 	console.log("RESTful = " + url);
	// 	return url;
	// }
}

export class ImgContainerAutoResize {
	container: HTMLElement;
	containerW: number = 0;
	ratio: number = 0;

	constructor(obj: HTMLElement, ratio: number) {
		this.container = obj;
		this.ratio = ratio;
		this.resizeWH();
		let _this = this;

		window.addEventListener('resize', () => {
			this.resizeWH();
		});

		this.container.addEventListener('click', () => {
			// alert(_this.container.offsetWidth + "  " + _this.container.offsetHeight);
		});
	}

	resizeWH() {
		this.containerW = this.container.offsetWidth;
		this.container.style.height = this.containerW * this.ratio + "px";
	}
}

export class Person {
	name: string = "";

	constructor(name:string) {
		this.name = name;
	}

	getName() {
		return this.name;
	}
}

export class NumRun {
	currentNum: number = 0;
	finalNum:number;
	numAdd: number;
	pointPos: number;
	fixedLength: number;
	arr: Array<string>;
	re: any;
	opacity: number;
	opacityPerSec: number;

	constructor(obj:HTMLElement, runSec:number) {
		this.finalNum = parseInt(obj.innerText);
		this.numAdd = this.finalNum/runSec;
		this.pointPos = obj.innerText.indexOf(".");
		this.fixedLength = (this.pointPos == -1 ? 0 : obj.innerText.length - (this.pointPos+1));
		this.arr = [];
		this.re = /(\d{1,3})(?=(\d{3})+$)/g;
		this.opacity = 0;
		this.opacityPerSec = 1 / 50;

		if(this.finalNum > 0) {
			let run:any = setInterval( () => {			
				this.currentNum += this.numAdd;	

				if(this.currentNum >= this.finalNum) {
					clearInterval(run);
					this.arr = this.finalNum.toFixed(this.fixedLength).split(".");
				} else {
					this.arr = this.currentNum.toFixed(this.fixedLength).split(".");
				}

				obj.innerText = this.arr[0].replace(this.re, "$1,") + (this.arr.length == 2 ? "." + this.arr[1] : "");
			});
		} else {
			let run:any = setInterval( () => {			
				this.currentNum += this.numAdd;	

				if(this.currentNum <= this.finalNum) {
					clearInterval(run);
					this.arr = this.finalNum.toFixed(this.fixedLength).split(".");
				} else {
					this.arr = this.currentNum.toFixed(this.fixedLength).split(".");
				}

				obj.innerText = this.arr[0].replace(this.re, "$1,") + (this.arr.length == 2 ? "." + this.arr[1] : "");
			});
		}

		let intervalOpacity = setInterval( () => {
			this.opacity += this.opacityPerSec;
			obj.style.opacity = this.opacity.toString();
	
			if(this.opacity > 1) {
				clearInterval(intervalOpacity);
				obj.style.opacity = "1";
			}
		}, 10);
	}
}